import httpClientePublicoLogin from '../../Servicios/httpClientePublicoLogin';

// Se encacarga de validar si existe cliente con el tipo de identificaci�n
export const validaIdentificacion = (identification, typeIdentificationId) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoLogin.post('/NuevoIngreso/ValidaIdentificacion/', {
            Identification: identification, TypeIdentificationId: typeIdentificationId
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encarga de validar el token del cliente
export const validaToken = (customerId, token) => {
    return new Promise((resolve, reject) => {
        httpClientePublicoLogin.post('/NuevoIngreso/ValidaToken/', { CustomerId: customerId, Token: token }).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


export default validaIdentificacion